import React from "react";
import {FaHeart} from "react-icons/all";

function Bookmarks() {

    return (
        <div className="Exlporer">
            <h1><span className="align-text-top"><FaHeart/></span> Bookmarks</h1>
            <div className="alert alert-warning mt-3">
                <h4>This page is under construction!</h4>
                <p>This will show bookmarked sounds.</p>
            </div>
        </div>
    );
}

export default Bookmarks;